<div class="bc-workitem-discussion-list">
  <div class="bc-sidenav-title-wrapper">
    <h2 class="bc-sidenav-title">
      <svg-icon icon="discussions"></svg-icon>
      <span class="bc-sidenav-title-label">{{ ( isHybrid ? 'discussionWorkitemList.dxTitleDiscussions' : 'discussionWorkitemList.titleDiscussions' ) | translate }}</span>
      <span> ({{ getActiveDiscussionsCount() }})</span>
    </h2>
  </div>

  <ul class="bc-workitem-titles-list">
    <li class="outer-item" [@taskItemAnimation]
        *ngFor="let discussion of discussionWorkItemList; trackBy: trackByItemId">
      <div class="item theme-orange-yellow traversable-list-item"
           [attr.tabindex]="0"
           [ngClass]="{ 'opened': isOpened(discussion), 'focus': isFocused(discussion.id) }"
           (click)="onDiscussionItemClicked(discussion)"
           (keydown)="onDiscussionItemKeydown($event, discussion)"
           [attr.data-automation-id]="'bc-discussion-traversable-item'">
        <div class="item-inner">
          <div class="visitor-avatar">
            <div class="visitor-avatar-inner-container">
              <div class="profile-initial" *ngIf="getInitials(discussion)">{{ getInitials(discussion) }}</div>
              <div class="discussion-widget" [ngClass]="getDiscussionAvatarClass(discussion.WorkItemID)">
                <div class="discussion-widget-avatar">
                  <div class="visitor-avatar-circle"></div>
                  <svg-avatar id="{{ discussion.avatarThemeId }}"></svg-avatar>
                </div>
              </div>
              <svg-icon icon="person-filled" *ngIf="!getInitials(discussion)"></svg-icon>
            </div>
          </div>

          <span class="discussion-sub-item-indicator" *ngIf="discussion.WorkItemType">
            <svg-icon [icon]="getSubWorkItemIcon(discussion)"></svg-icon>
          </span>

          <div class="visitor-name" [attr.data-automation-id]="'bc-discussion-visitor-name'">{{ discussion.OperatorName }}</div>

          <div class="messages">
            <div class="message" *ngFor="let message of discussion.messages" [innerHTML]="message.text"></div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</div>

